export default function sorts(state = {}, action) {
  const { type } = action;
  if (type === 'SET_SORT_ITEMS') {
    const { items = [] } = action;
    return { ...state, results: items };
  }
  return state;
}
